import { ProductProps } from '@components/tickets/StoresSaleProductList'
import { Box, Container, Grid, useMediaQuery } from '@material-ui/core'
import { Theme, useTheme } from '@material-ui/core/styles'
import { Maybe, StoresTicketInfoPanelFragment } from '@ts/operations'
import React from 'react'

import OverviewPanel, { OverviewPanelProps } from '../applications/OverviewPanel'
import Panel from '../apply-for-ticket/Panel'
import StoresTicketInfoGrid from '../apply-for-ticket/StoresTicketInfoGrid'
import DynamicFormstackForm, { DynamicFormstackFormProps } from '../forms/DynamicFormstackForm'
import Markdown from '../utils/Markdown'
import { H1, H4 } from '../utils/typography'

type StoresTicketApplicationsPageProps = {
  country: string
  currencySymbol: Maybe<string>
  description?: Maybe<string>
  overviewPanel?: Maybe<OverviewPanelProps>
  priceIncreaseCountdownProductId?: Maybe<string>
  product?: ProductProps
  releasePhaseStepperProductId?: Maybe<string>
  ticketApplicationForm?: Maybe<DynamicFormstackFormProps>
  ticketInfoPanel?: Maybe<StoresTicketInfoPanelFragment>
  title?: Maybe<string>
}

const StoresTicketApplicationsPage = ({
  description,
  country,
  currencySymbol,
  title,
  ticketApplicationForm,
  ticketInfoPanel,
  overviewPanel,
  product,
}: Partial<StoresTicketApplicationsPageProps>) => {
  const { breakpoints } = useTheme<Theme>()
  const mdUp = useMediaQuery(breakpoints.up('md'))

  const form = ticketApplicationForm && (
    <DynamicFormstackForm {...ticketApplicationForm} submitText="Apply now" />
  )
  let titleComponent = title && (
    <H4 mb={2} variantMapping={{ h4: 'h1' }}>
      {title}
    </H4>
  )
  if (mdUp && title) titleComponent = <H1>{title}</H1>

  return (
    <Container>
      {(title || description) && (
        <Box mb={mdUp ? 7 : 3} mt={mdUp ? 8 : 3} px={2}>
          {titleComponent}
          {description && <Markdown source={description} />}
        </Box>
      )}

      <Box pb={8}>
        <Grid container spacing={4}>
          {ticketInfoPanel && (
            <StoresTicketInfoGrid
              applicationForm={form}
              country={country || ''}
              currencySymbol={currencySymbol || ''}
              product={product}
              ticketInfoPanel={ticketInfoPanel}
            />
          )}

          {overviewPanel && mdUp && (
            <Grid item md={4} xs={12}>
              <OverviewPanel {...overviewPanel} />
            </Grid>
          )}

          {!ticketInfoPanel && form && (
            <Grid item md={8} xs={12}>
              <Panel>{form}</Panel>
            </Grid>
          )}
        </Grid>
      </Box>
    </Container>
  )
}

export default StoresTicketApplicationsPage
